<template>
  <div class="main">
    <div class="main__container">
      <!-- <img src="/img/idp-logo.png" /> -->
      <div class="main__box">
        <logo-ui img-src="/img/idp-logo.png" description="Indopride Logo"></logo-ui>
        <h1>Indopride Central Mobile Data Terminal</h1>
        <p v-if="errorMsg !== ''" class="error">{{errorMsg}}</p>
        <login-form @setErrorMessage="handleMsg"></login-form>
      </div>
    </div>
    
  </div>
</template>

<script>
  import LogoUi from '../UI/LogoUi.vue'
  import LoginForm from '../UI/LoginForm.vue'
  export default {
    components: {
      LogoUi,
      LoginForm
    },
    data() {
      return {
        errorMsg: ''
      }
    },
    methods: {
      handleMsg(msg) {
        this.errorMsg = msg;
      }
    }
  }
</script>

<style scoped>
  .main {
    width: 100vw;
    background: url('../../../public/img/bg.jpg') center center/cover no-repeat;
  }
  .main__container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100vh;
  }
  .main__box {
    width: 50%;
    margin: 0 auto;
    background: #2F6E2C;
    border: solid 7px white;
    background: linear-gradient(to bottom right, #00aba2 0%, #018e1b 100%);
    border-radius: 10px;
    max-width: 800px;
    /* background: linear-gradient(to right, #8084DF 0%, #CA909B 100%); */
  }
  h1 {
    font-size: 1.9em;
  }
  .error {
    margin-top: 20px;
    font-size: 1.5em;
    color: #c50000;
    font-weight: 600;
  }
</style>